import React from 'react';
import ConnectedModal from 'containers/ConnectedModal';
import YouTubeMostReplayedUpsellModalContents from './YouTubeMostReplayedUpsellModalContents';

export interface YouTubeMostReplayedUpsellModalProps {}

const YouTubeMostReplayedUpsellModal: React.FC<YouTubeMostReplayedUpsellModalProps> = () => (
  <ConnectedModal name="YouTubeMostReplayedUpsell" title="most replayed">
    <YouTubeMostReplayedUpsellModalContents />
  </ConnectedModal>
);

export default YouTubeMostReplayedUpsellModal;
